var iota = require("iota-array")
var isBuffer = require("is-buffer")

var hasTypedArrays  = ((typeof Float64Array) !== "undefined")

function compare1st(a, b) {
  return a[0] - b[0]
}

function order() {
  var stride = this.stride
  var terms = new Array(stride.length)
  var i
  for(i=0; i<terms.length; ++i) {
    terms[i] = [Math.abs(stride[i]), i]
  }
  terms.sort(compare1st)
  var result = new Array(terms.length)
  for(i=0; i<result.length; ++i) {
    result[i] = terms[i][1]
  }
  return result
}

function compileConstructor(dtype, dimension) {

  if (dimension === -1 || dimension === 0) {
    return () => {}
  }

  const covjsonReaderFunc = (CTOR_LIST, ORDER) => {
    'use strict'
    function View2darray(a,b0,b1,c0,c1,d){this.data=a
    this.shape=[b0,b1]
    this.stride=[c0,c1]
    this.offset=d|0}
    var proto=View2darray.prototype
    proto.dtype='array'
    proto.dimension=2
    Object.defineProperty(proto,'size',{get:function View2darray_size(){return this.shape[0]*this.shape[1]
    }})
    Object.defineProperty(proto,'order',{get:
    function View2darray_order(){
    return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})
    proto.set=function View2darray_set(i0,i1,v){
    return this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1]=v}
    proto.get=function View2darray_get(i0,i1){
    return this.data[this.offset+this.stride[0]*i0+this.stride[1]*i1]}
    proto.index=function View2darray_index(
    i0,i1
    ){return this.offset+this.stride[0]*i0+this.stride[1]*i1}
    proto.hi=function View2darray_hi(i0,i1){return new View2darray(this.data,(typeof i0!=='number'||i0<0)?this.shape[0]:i0|0,(typeof i1!=='number'||i1<0)?this.shape[1]:i1|0,this.stride[0],this.stride[1],this.offset)}
    proto.lo=function View2darray_lo(i0,i1){var b=this.offset,d=0,a0=this.shape[0],a1=this.shape[1],c0=this.stride[0],c1=this.stride[1]
    if(typeof i0==='number'&&i0>=0){d=i0|0;b+=c0*d;a0-=d}
    if(typeof i1==='number'&&i1>=0){d=i1|0;b+=c1*d;a1-=d}
    return new View2darray(this.data,a0,a1,c0,c1,b)}
    proto.step=function View2darray_step(i0,i1){var a0=this.shape[0],a1=this.shape[1],b0=this.stride[0],b1=this.stride[1],c=this.offset,d=0,ceil=Math.ceil
    if(typeof i0==='number'){d=i0|0;if(d<0){c+=b0*(a0-1);a0=ceil(-a0/d)}else{a0=ceil(a0/d)}b0*=d}
    if(typeof i1==='number'){d=i1|0;if(d<0){c+=b1*(a1-1);a1=ceil(-a1/d)}else{a1=ceil(a1/d)}b1*=d}
    return new View2darray(this.data,a0,a1,b0,b1,c)}
    proto.transpose=function View2darray_transpose(i0,i1){i0=(i0===undefined?0:i0|0);i1=(i1===undefined?1:i1|0)
    var a=this.shape,b=this.stride;return new View2darray(this.data,a[i0],a[i1],b[i0],b[i1],this.offset)}
    proto.pick=function View2darray_pick(i0,i1){var a=[],b=[],c=this.offset
    if(typeof i0==='number'&&i0>=0){c=(c+this.stride[0]*i0)|0}else{a.push(this.shape[0]);b.push(this.stride[0])}
    if(typeof i1==='number'&&i1>=0){c=(c+this.stride[1]*i1)|0}else{a.push(this.shape[1]);b.push(this.stride[1])}
    var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}
    return function construct_View2darray(data,shape,stride,offset){return new View2darray(data,shape[0],shape[1],stride[0],stride[1],offset)}
  }

  return covjsonReaderFunc(CACHED_CONSTRUCTORS[dtype], order)
}

function arrayDType(data) {
  if(isBuffer(data)) {
    return "buffer"
  }
  if(hasTypedArrays) {
    switch(Object.prototype.toString.call(data)) {
      case "[object Float64Array]":
        return "float64"
      case "[object Float32Array]":
        return "float32"
      case "[object Int8Array]":
        return "int8"
      case "[object Int16Array]":
        return "int16"
      case "[object Int32Array]":
        return "int32"
      case "[object Uint8Array]":
        return "uint8"
      case "[object Uint16Array]":
        return "uint16"
      case "[object Uint32Array]":
        return "uint32"
      case "[object Uint8ClampedArray]":
        return "uint8_clamped"
      case "[object BigInt64Array]":
        return "bigint64"
      case "[object BigUint64Array]":
        return "biguint64"
    }
  }
  if(Array.isArray(data)) {
    return "array"
  }
  return "generic"
}

var CACHED_CONSTRUCTORS = {
  "float32":[],
  "float64":[],
  "int8":[],
  "int16":[],
  "int32":[],
  "uint8":[],
  "uint16":[],
  "uint32":[],
  "array":[],
  "uint8_clamped":[],
  "bigint64": [],
  "biguint64": [],
  "buffer":[],
  "generic":[]
}

;(function() {
  for(var id in CACHED_CONSTRUCTORS) {
    CACHED_CONSTRUCTORS[id].push(compileConstructor(id, -1))
  }
});

function wrappedNDArrayCtor(data, shape, stride, offset) {
  if(data === undefined) {
    var ctor = CACHED_CONSTRUCTORS.array[0]
    return ctor([])
  } else if(typeof data === "number") {
    data = [data]
  }
  if(shape === undefined) {
    shape = [ data.length ]
  }
  var d = shape.length
  if(stride === undefined) {
    stride = new Array(d)
    for(var i=d-1, sz=1; i>=0; --i) {
      stride[i] = sz
      sz *= shape[i]
    }
  }
  if(offset === undefined) {
    offset = 0
    for(var i=0; i<d; ++i) {
      if(stride[i] < 0) {
        offset -= (shape[i]-1)*stride[i]
      }
    }
  }
  var dtype = arrayDType(data)
  var ctor_list = CACHED_CONSTRUCTORS[dtype]
  while(ctor_list.length <= d+1) {
    ctor_list.push(compileConstructor(dtype, ctor_list.length-1))
  }
  var ctor = ctor_list[d+1]
  return ctor(data, shape, stride, offset)
}

module.exports = wrappedNDArrayCtor
